// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".map_a {\n  height: 16.56rem !important;\n}\na {\n  color: #C99700;\n}", ""]);
// Exports
module.exports = exports;
